export default "__VITE_ASSET__DLKYODSo__"